import { GenerateCodeTeacherType, TeacherDepartamentType, TeacherDocumentType, TeacherType } from "../../../types/Teacher";
import { post } from "../../../utils/axios-config";
import { TEACHER_CREATE_CODE, TEACHERS, TEACHERS_DEPARTAMENTS, TEACHERS_DOCUMENTS, TEACHERS_SYNC } from "../../../utils/constants";

export const createTeacher = async (data: TeacherType) => await post<TeacherType, string>(TEACHERS, data);

export const createTeacherCode = async (data: GenerateCodeTeacherType) => await post<GenerateCodeTeacherType, string>(TEACHER_CREATE_CODE, data);

export const createTeacherDepartament = async (data: TeacherDepartamentType) => await post<TeacherDepartamentType, string>(TEACHERS_DEPARTAMENTS, data);

export const createTeacherDocument = async (data: TeacherDocumentType) => await post<TeacherDocumentType, string>(TEACHERS_DOCUMENTS, data);

export const syncTeacher = async (data: any) => await post<any, boolean>(TEACHERS_SYNC, data);
